import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { faUserCircle } from "@fortawesome/free-regular-svg-icons";
import {
  Nav,
  Image,
  Navbar as BootstrapNavbar,
  Dropdown,
  Container,
  Form,
} from "@themesberg/react-bootstrap";
import { useHistory } from "react-router-dom";

import { useAuth } from "../contexts/AuthContext";
import { useAcademicYear } from "../contexts/AcademicYearContext";
import { useSchool } from "../contexts/SchoolContext";
import { Routes } from "../routes";
import { Link } from "react-router-dom";
import NOTIFICATIONS_DATA from "../data/notifications";
import Profile3 from "../assets/img/team/profile.jpg";

const Navbar = (props) => {
  const [notifications, setNotifications] = useState(NOTIFICATIONS_DATA);
  // const areNotificationsRead = notifications.reduce((acc, notif) => acc && notif.read, true);

  const { logout, user } = useAuth();
  const { selectedYear, setSelectedYear, availableYears, loading } = useAcademicYear();
  const { selectedSchool, setSelectedSchool, availableSchools, loading: loadingSchools } = useSchool();
  const history = useHistory();

  const markNotificationsAsRead = () => {
    setTimeout(() => {
      setNotifications(notifications.map((n) => ({ ...n, read: true })));
    }, 300);
  };

  const handleLogout = () => {
    logout();
    history.push(Routes.Login.path);
  };

  // const Notification = (props) => {
  //   const { link, sender, image, time, message, read = false } = props;
  //   const readClassName = read ? "" : "text-danger";

  //   return (
  //     <ListGroup.Item action href={link} className="border-bottom border-light">
  //       <Row className="align-items-center">
  //         <Col className="col-auto">
  //           <Image src={image} className="user-avatar lg-avatar rounded-circle" />
  //         </Col>
  //         <Col className="ps-0 ms--2">
  //           <div className="d-flex justify-content-between align-items-center">
  //             <div>
  //               <h4 className="h6 mb-0 text-small">{sender}</h4>
  //             </div>
  //             <div className="text-end">
  //               <small className={readClassName}>{time}</small>
  //             </div>
  //           </div>
  //           <p className="font-small mt-1 mb-0">{message}</p>
  //         </Col>
  //       </Row>
  //     </ListGroup.Item>
  //   );
  // };

  return (
    <BootstrapNavbar variant="dark" expanded className="ps-0 pe-2 pb-0">
      <Container fluid className="px-0">
        <div className="d-flex justify-content-end w-100">
          <Nav className="align-items-center ms-auto">
            {/* Seletor de Escola */}
            {availableSchools.length > 0 && (
              <Nav.Item className="me-3">
                <div className="d-flex align-items-center">
                  <span className="text-dark me-2 fw-bold text-nowrap">Escola:</span>
                  <Form.Select
                    size="sm"
                    value={selectedSchool || ''}
                    onChange={(e) => setSelectedSchool(e.target.value)}
                    disabled={loadingSchools || availableSchools.length === 1}
                    style={{
                      minWidth: '200px',
                      maxWidth: '400px',
                      cursor: availableSchools.length === 1 ? 'not-allowed' : 'pointer',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap'
                    }}
                    className="border-0 shadow-sm"
                  >
                    {availableSchools.map(school => (
                      <option key={school.id} value={school.id} title={school.name}>
                        {school.name}
                      </option>
                    ))}
                  </Form.Select>
                </div>
              </Nav.Item>
            )}

            {/* Seletor de Ano Letivo */}
            <Nav.Item className="me-3">
              <div className="d-flex align-items-center">
                <span className="text-dark me-2 fw-bold">Ano Letivo:</span>
                <Form.Select
                  size="sm"
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                  disabled={loading}
                  style={{ width: '100px', cursor: 'pointer' }}
                  className="border-0 shadow-sm"
                >
                  {availableYears.map(year => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </Form.Select>
              </div>
            </Nav.Item>
            <Dropdown as={Nav.Item} onToggle={markNotificationsAsRead}>
              <Dropdown.Toggle as={Nav.Link} className="text-dark icon-notifications me-lg-3">
                <span className="icon icon-sm">
                  <FontAwesomeIcon icon={faBell} className="bell-shake" />
                  {/* {areNotificationsRead ? null : <span className="icon-badge rounded-circle unread-notifications" />} */}
                </span>
              </Dropdown.Toggle>
              {/* <Dropdown.Menu className="dashboard-dropdown notifications-dropdown dropdown-menu-lg dropdown-menu-center mt-2 py-0">
                <ListGroup className="list-group-flush">
                  <Nav.Link href="#" className="text-center text-primary fw-bold border-bottom border-light py-3">
                    Notifications
                  </Nav.Link>

                  {notifications.map(n => <Notification key={`notification-${n.id}`} {...n} />)}

                  <Dropdown.Item className="text-center text-primary fw-bold py-3">
                    View all
                  </Dropdown.Item>
                </ListGroup>
              </Dropdown.Menu> */}
            </Dropdown>

            <Dropdown as={Nav.Item}>
              <Dropdown.Toggle as={Nav.Link} className="pt-1 px-0">
                <div className="media d-flex align-items-center">
                  <Image src={Profile3} className="user-avatar md-avatar rounded-circle" />
                  <div className="media-body ms-2 text-dark align-items-center d-none d-lg-block">
                    <span className="mb-0 font-small fw-bold">
                      {user?.name
                        ? user.name
                            .split(" ")
                            .map(
                              (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                            )
                            .join(" ")
                        : "Usuário"}
                    </span>
                  </div>
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu className="user-dropdown dropdown-menu-right mt-2">
                <Dropdown.Item as={Link} to={Routes.Profile.path} className="fw-bold">
                  <FontAwesomeIcon icon={faUserCircle} className="me-2" /> Perfil
                </Dropdown.Item>

                <Dropdown.Divider />

                <Dropdown.Item className="fw-bold" onClick={handleLogout}>
                  <FontAwesomeIcon icon={faSignOutAlt} className="text-danger me-2" /> Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </div>
      </Container>
    </BootstrapNavbar>
  );
};

export default Navbar;
